import { CircleUser, LogOut } from 'lucide-react'
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '../components/ui/popover'
import { Button } from './ui/button'
import { useLocation, useNavigate } from 'react-router-dom'
import { useToast } from './ui/use-toast'
import { ClipLoader } from 'react-spinners'
import { resetAuth } from '../store/features/authSlice'
import { useDispatch } from 'react-redux'
import { resetClients } from '../store/features/clientSlice'
import { useLogoutUser } from '../migration-api/api-hooks/auth'

const UserQuickAction = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const { toast } = useToast()
  //   const [isLoading, setIsLoading] = useState(false)
  const { logout, isLoading } = useLogoutUser({
    onSuccess: () => {
      toast({
        variant: 'success',
        title: 'Success',
        description: `${'Logout successful'}`
      })

      dispatch(resetAuth())
      dispatch(resetClients())
      //   setIsLoading(false)
      navigate('/', { state: { from: location }, replace: true })
    },
    onError: error => {
      console.log('error', error)
      toast({
        variant: 'destructive',
        title: 'Error',
        description: `${error?.message || 'An error occured, please try again'}`
      })
    }
  })

  const handleLogOut = async () => {
    logout()
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <CircleUser size={20} cursor={'pointer'} />
      </PopoverTrigger>
      <PopoverContent className='w-[100%] mt-1' align={'end'}>
        <Button
          onClick={handleLogOut}
          disabled={isLoading}
          variant='outline'
          className='border-0 shadow-none disabled:!cursor-default disabled:!bg-muted'
        >
          {isLoading ? (
            <span className='flex items-center gap-2 justify-between'>
              <ClipLoader color='primary' size={20} />
              Logging out
            </span>
          ) : (
            <span className='flex items-center gap-2 justify-between'>
              <LogOut size={20} strokeWidth={1.5} />
              Log out
            </span>
          )}
        </Button>
      </PopoverContent>
    </Popover>
  )
}

export default UserQuickAction
